import { backendClient } from '@/lib/api-client';
import type { AnalysisSetState, AnalysisSetStatus } from './useDocuments';

export const DEEP_ANALYSIS_LABEL = 'Deep Analysis';

const DEEP_ANALYSIS_LOCKED_STATUSES = new Set<AnalysisSetStatus>([
  'queued',
  'processing',
  'removing',
]);

export function isDeepAnalysisTransitioning(status?: AnalysisSetStatus | string | null): boolean {
  return status === 'queued' || status === 'processing' || status === 'removing';
}

export function canToggleDeepAnalysis(status?: AnalysisSetStatus | string | null): boolean {
  return !isDeepAnalysisTransitioning(status);
}

export function getDeepAnalysisTransitionLabel(status?: AnalysisSetStatus | string | null): string | null {
  if (!DEEP_ANALYSIS_LOCKED_STATUSES.has(status as AnalysisSetStatus)) return null;
  if (status === 'removing') return `${DEEP_ANALYSIS_LABEL} removal pending`;
  return `${DEEP_ANALYSIS_LABEL} integration pending`;
}

export async function setFileAnalysisSetState(
  matterSlug: string,
  fileReferenceGuid: string,
  state: AnalysisSetState,
) {
  const response = await backendClient.put(
    `/matter/${matterSlug}/analysis-set/files/${fileReferenceGuid}`,
    { state },
  );
  return response.data;
}

export async function setFolderAnalysisSetState(
  matterSlug: string,
  folderGuid: string,
  state: AnalysisSetState,
) {
  const response = await backendClient.put(
    `/matter/${matterSlug}/analysis-set/folders/${folderGuid}`,
    { state },
  );
  return response.data;
}
